import { createForm, yup } from '@codeleap/common'
import { I18N } from '../i18n'

export const communityPostForm = (prompt = false, required = false, isFile = false) => {
  let titleValidator = yup.string()

  let descriptionValidator = yup.string()

  if (required) {
    if (!prompt) {
      titleValidator = titleValidator.required(I18N.t('form.validations.required')).min(5, 'Minimum of 5 characters')
    }

    if (!isFile && !prompt) {
      descriptionValidator = descriptionValidator
        .required(I18N.t('form.validations.required'))
        .min(5, 'Minimum of 5 characters')
    }
  }

  titleValidator = titleValidator.trim().max(140, 'Maximum of 140 characters')
  descriptionValidator = descriptionValidator.trim().max(500, 'Maximum of 500 characters')

  return createForm('post', {
    title: {
      type: 'text',
      label: 'Title',
      placeholder: 'Type your title',
      validate: titleValidator
    },
    description: {
      type: 'text',
      label: prompt ? '' : 'Description',
      placeholder: prompt ? 'Type your answer here' : 'Description',
      validate: descriptionValidator,
      multiline: true
    }
  })
}

export type CommunityFormValue = ReturnType<typeof communityPostForm>['defaultValue']
